export default "__VITE_ASSET__BOeD91a8__"